//This clears the hamburger menu if the Back button is clicked in the browser
(function () {
window.onpageshow = function(event) {
  if (event.persisted) {
    window.location.reload();
  }
};
})();
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};
jQuery(document).ready( function() {
  //Scroller arrow link on the home page hero section
  jQuery("#scrollerDown").on("click touchstart", function(e) {
    e.preventDefault();
    jQuery("html, body").animate({
      scrollTop: jQuery("#scrollerDown").offset().top
    }, 1400);
  });
  //Hamburger menu opener
  jQuery(".hamburger").on("click touch", function() {
    jQuery(".hamburger").toggleClass("is-active");
    jQuery(".hamMenuBlock").removeClass("hamMenuStart");
    jQuery(".hamMenuBlock").toggleClass("hamMenuBlockOpen");
    jQuery(".hamMenuBlock").toggleClass("hamMenuBlockClose");
    //jQuery("body").toggleClass("scrollStopper");
    if (jQuery(".hamMenuBlock").hasClass("hamMenuBlockClose")) {
      jQuery(".hamMenuBlock").delay(700).queue(function(next){
        jQuery(".hamMenuBlock").addClass("hamMenuStart");;
        next();
      });
    }
  });
  //Hamburger menu sub menus
  jQuery('.hamMenuLinkSubArrow').on('click', function(){
    var thisAnswer = jQuery(this).parent().nextAll('.hamMenuLinkMainSubBlock').first();
    var thisQuestion = jQuery(this).parent();
    jQuery('.hamMenuLinkMainSubBlock').not(thisAnswer).slideUp('fast');
    jQuery(thisAnswer).slideToggle('fast');
    jQuery('.hamMenuLinkSubArrow').parent().not(thisQuestion).removeClass('hamMenuLinkMainActive');
    jQuery(thisQuestion).toggleClass('hamMenuLinkMainActive');
    jQuery('.hamMenuLinkSubArrow').not(this).removeClass('hamMenuLinkSubArrowUp');
    jQuery(this).toggleClass('hamMenuLinkSubArrowUp');
  });
  //Add active class to the main navigation
  jQuery('#pursuit_main_nav a.nav-link').filter(function(){
    return this.href === location.href;
  }).addClass('pursuit_active_main_nav');
  //Keep the active class styles on when hovering inside a dropdown
  jQuery('.dropdown-menu').hover(function(){
    var thisMain = jQuery(this).prev().find('span');
    jQuery(this).prev().find('span').addClass("nav-link__active");
  }, function () {
    jQuery(this).prev().find('span').removeClass("nav-link__active");
  });
  //Add title attribute to all iframe elements
  if (!jQuery('iframe').attr('title')) {
    jQuery('iframe').attr('title', 'Content from COMPANYNAME');
  }
  //Add numbering to BS carousel
  var totalSliderItems = jQuery('.carousel-item').length;
  var currentSliderIndex = jQuery('div.carousel-item.active').index() + 1;
  jQuery('.pmodule_luxslider_pages').html('' + currentSliderIndex + ' / ' + totalSliderItems + '');
  jQuery('#pursuitLuxurySlider').on('slid.bs.carousel', function() {
    currentSliderIndex = jQuery('div.carousel-item.active').index() + 1;
    jQuery('.pmodule_luxslider_pages').html('' + currentSliderIndex + ' / ' + totalSliderItems + '');
  });
  //Accordion module
  jQuery('.pd_accordionItemTitle').click(function(){
    jQuery(this).attr('aria-expanded', function(index, attr){
      return attr == 'false' ? 'true' : 'false';
    });
    var thisContent = jQuery(this).next('.pd_accordionItemContent');
    jQuery('.pd_accordionItemContent').not(thisContent).slideUp('fast').attr('aria-hidden', 'true');
    jQuery(thisContent).slideToggle('fast').attr('aria-hidden', function(index, attr){
      return attr == 'true' ? 'false' : 'true';
    });
    jQuery('.pd_accordionItemTitle').not(this).removeClass('pd_accordionItemTitleOn').attr('aria-expanded', 'false');
    jQuery(this).toggleClass('pd_accordionItemTitleOn');
  });
  //Offset anchor links so they don't hide behind fixed menu
  // jQuery(document).on('click', 'a[href^="#"]', function (event) {
  //   event.preventDefault();
  //     jQuery('html, body').animate({
  //         scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top + -360
  //     }, 1000);
  // });
  //Destination Carousel module - uses Slick.js
  var $destcarousel = jQuery('.pmodule_destcar');
  if ($destcarousel.length) {
    var currentDestSlide;
    var slidesDestCount;
    var sliderDestCounter = jQuery('div.pmodule_destcar__pages');

    var updateDestSliderCounter = function(slick, currentIndex) {
      currentDestSlide = slick.slickCurrentSlide() + 1;
      slidesDestCount = slick.slideCount;
      jQuery(sliderDestCounter).text(currentDestSlide + ' / ' +slidesDestCount)
    };

    $destcarousel.on('init', function(event, slick) {
      updateDestSliderCounter(slick);
    });

    $destcarousel.on('afterChange', function(event, slick, currentDestSlide) {
      updateDestSliderCounter(slick, currentDestSlide);
    });

    $destcarousel.slick({
      speed: 800,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: jQuery('.pmodule_destcar_prev'),
      nextArrow: jQuery('.pmodule_destcar_next'),
      responsive: [{
        breakpoint: 1009,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 782,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  }
});
